// extracted by mini-css-extract-plugin
export default {"btn":"ExternalShipments_btn__rk-45"};